module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av550-db1aeb9c639bc5519b29623d1bbd022c.jpg";